import {
  NativeActionsList,
  IActionContextAPI,
} from '@wix/editor-platform-host-integration-apis';
import { Action, DashboardAction } from '@wix/component-protocol/schema';
import { PlatformContext } from '../types';

export class ActionContextAPI implements IActionContextAPI {
  constructor(
    private readonly action: Action | DashboardAction,
    private readonly actionName: keyof typeof NativeActionsList,
    private readonly context: PlatformContext,
  ) {}

  getData() {
    return this.context.componentsAPI.editActions.resolveDataItems(
      this.actionName,
      this.context.editorPointer,
    );
  }

  getStyle() {
    return this.context.componentsAPI.get.style(this.context.editorPointer);
  }

  getActionDefinition() {
    return this.action;
  }
}
